import React, { Component } from "react";
import { Chart } from "react-google-charts";
import {
  Row,
  Col,
  List,
  Card,
  Collapse,
  Typography,
  Tooltip,
  Icon,
  Skeleton,
  Button,
  message
} from "antd";
import * as loginActions from "../../actions";
import { connect } from "react-redux";

const { Panel } = Collapse;
const { Paragraph } = Typography;

function groupBy(arr, property) {
  return arr.reduce((memo, x) => {
    if (!memo[x[property]]) {
      memo[x[property]] = [];
    }
    memo[x[property]].push(x);
    return memo;
  }, {});
}

class CodeChef extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      user_profile: [
        {
          "Problem Solved": "14"
        },
        {
          "Solutions Submitted": "53"
        },
        {
          "Solutions Accepted": "25"
        },
        {
          "Wrong Answer": "23"
        },
        {
          "Compile Error": "4"
        },
        {
          "Runtime Error": "0"
        },
        {
          "Time Limit Exceeded": "1"
        }
      ],
      category: [],
      loading: false,
      uid: ""
    };
  }

  setLoading = loading => {
    this.setState({ loading });
  };

  componentDidMount() {
    if (this.state.uid !== this.props.uid) {
      this.props.fetchSolvedProblems(
        "codechef",
        this.props.uid,
        this.setLoading
      );

      this.setState({ uid: this.props.uid });
    }
  }

  componentWillReceiveProps(props) {
    if (props.userSolvedProblems.uid === props.uid) {
      const data = props.userSolvedProblems.data.map(problem => {
        return {
          title: problem.title,
          href: problem.link
        };
      });
      const category = [["Task", "Hours per Day"]];
      const o = groupBy(props.userSolvedProblems.data, "category");
      // const unique = [...new Set(data.solved_problems.map(item => item.track))];
      Object.keys(o).forEach(i => {
        category.push([i, o[i].length]);
      });
      this.setState({
        data,
        category
      });
    } else {
      this.props.fetchSolvedProblems(
        "codechef",
        this.props.uid,
        this.setLoading
      );

      this.setState({ uid: this.props.uid });
    }
  }
  updateUserSolvedProblems = e => {
    this.setState({ loading: true });
    fetch(
      `https://us-central1-vedicplatform.cloudfunctions.net/solvedProblems/api/frontend/solved_problems/v1.0/codechef/`,
      {
        method: "post",
        body: JSON.stringify({
          userName: this.props.userName,
          userID: this.props.uid
        }),
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(b =>
        b.json().then(res => {
          this.setState({ loading: false });
          if (res.updated) {
            this.props.fetchSolvedProblems(
              "codechef",
              this.props.uid,
              this.setLoading
            );
            message.success("Solved Problems Fetched");
          }
        })
      )
      .catch(err => {
        this.setState({ loading: false });
      });
  };
  render() {
    const { data, user_profile, category } = this.state;
    
    // 
    
    return (
      <div>
        <Row gutter={12}>
          <Col span={12}>
            <Button
              type="primary"
              icon="reload"
              loading={this.state.loading}
              onClick={this.updateUserSolvedProblems}
            >
              {"UPDATE"}
            </Button>
            <h3>{"  Problems Solved"}</h3>

            <Skeleton
              active
              paragraph={{ rows: 4 }}
              loading={this.state.uid !== this.props.uid}
            >
              <List
                grid={{ gutter: 5, column: 3 }}
                dataSource={data}
                pagination={{
                  pageSize: 10,
                  style: { "text-align": "center" }
                }}
                renderItem={item => (
                  <List.Item>
                    <Tooltip title={item.title}>
                      <a href={item.href} target="_blank">
                        <div
                          style={{
                            border: "1px solid #e8e8e8",
                            padding: "7px",
                            background: "#fff",
                            borderRadius: "2px",
                            transition: "all 0.3s",
                            fontSize: "16px",
                            cursor: "pointer"
                          }}
                        >
                          <Paragraph ellipsis={{ rows: 1, expandable: false }}>
                            {item.title}
                          </Paragraph>
                        </div>
                      </a>
                    </Tooltip>
                  </List.Item>
                )}
              />
            </Skeleton>
          </Col>
          <Col span={12}>
            <Collapse accordion defaultActiveKey={["2"]}>
              <Panel header="Stats" key="1">
                {data && (
                  <Chart
                    width="500px"
                    height="300px"
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={[
                      ["Task", "Hours per Day"],
                      [
                        `Problem Solved(${user_profile[0]["Problem Solved"]})`,
                        user_profile[0]["Problem Solved"] / 10
                      ],
                      [
                        `Submitted(${user_profile[1]["Solutions Submitted"]})`,
                        user_profile[1]["Solutions Submitted"] / 10
                      ],
                      [
                        `Solutions Accepted(${
                          user_profile[2]["Solutions Accepted"]
                        })`,
                        user_profile[2]["Solutions Accepted"] / 10
                      ],
                      [
                        `Wrong Answer(${user_profile[3]["Wrong Answer"]})`,
                        user_profile[3]["Wrong Answer"] / 10
                      ]
                    ]}
                    options={{
                      colors: ["#3366CC", "#FF9900", "#0F9417", "#DC3912"],
                      is3D: true
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                )}
              </Panel>
              <Panel header="Problem Categories" key="2">
                {category && (
                  <Chart
                    width="500px"
                    height="300px"
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={category}
                    options={{
                      is3D: true
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                )}
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // 
  // 
  return {
    userSolvedProblems: state.auth.userSolvedProblems
  };
};

const mapDispachToProps = (dispatch, props) => ({
  fetchSolvedProblems: (websiteName, UID, setLoading) => {
    // 
    dispatch(loginActions.fetchSolvedProblems(websiteName, UID, setLoading));
  }
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(CodeChef);
